import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Color } from '../../../../assets/color';
import { useNavigate, useSearchParams } from 'react-router-dom';
import RouteHeader from '../../../../components/common/RouteHeader';
import DatatableHeading from '../../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../../components/datatable/DatatableWithSearch';
import * as AdminActions from '../../../../redux/actions/adminAction';

const PartnerCustomer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParam, setSearchParam] = useSearchParams();
    const partnerId = searchParam.get('id') || '';
    const partner_name = searchParam.get('name') || '';

    const { customerByPartnerIdData } = useSelector(state => state?.adminReducer);

    //* Datatable Columns
    const columns = [
        { name: 'S.No.', selector: row => customerByPartnerIdData?.indexOf(row) + 1, width: '80px' },
        { name: 'Customer Name', selector: row => row?.customer_name },
        { name: 'Mobile No.', selector: row => row?.mobile_number || '...' },
        { name: 'Email ID', selector: row => row?.email || '...', width: '250px' },
        { name: 'Password', selector: row => row?.password || '...' },
        { name: 'Gender', selector: row => row?.gender || '...' },
        { name: 'State', selector: row => row?.state || '...' },
        { name: 'City', selector: row => row?.city || '...' },
        { name: 'Date of birth', selector: row => moment(row?.date_of_birth).format('DD MMM YYYY') || '...' },
        { name: 'Wallet Balance', selector: row => row?.report_wallet_balance || '...' },
    ];

    useEffect(() => {
        //! Dispatching API
        dispatch(AdminActions.getCustomerByPartnerId({ partnerId }));
    }, []);

    return (
        <>
            <RouteHeader title={`${partner_name} Customers`} sub_title={`View customers information`} />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <Grid container spacing={6} >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableHeading title={`${partner_name} Customers Management Information System`} />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={customerByPartnerIdData} columns={columns} />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default PartnerCustomer;